export default __webpack_public_path__ + "static/28d-pay-local-4749ec23d8f02961dd4b3adf87ee056a.webp";